import styled from 'styled-components'

const StyledConfirmationView = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  user-select: none;
  background-color: ${({ theme }) => theme.color.gray[100]};

  .confirmation-container {
    max-width: 360px;
    width: 100vw;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 2px 2px rgb(0, 0, 0, 0.1), 0 2px 10px rgb(0, 0, 0, 0.1);
    background-color: ${({ theme }) => theme.color.background};

    .icon {
      height: 60px;
      width: 60px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: ${({ theme }) => theme.color.background};
      background-color: ${({ theme }) => theme.color.green[700]};

      svg {
        height: 28px;
        width: 28px;
        position: relative;
        top: 1px;
        stroke-width: 3px;
      }
    }

    h1 {
      margin-top: 20px;
      font-weight: 700;
      font-size: 26px;
      color: ${({ theme }) => theme.color.gray[900]};
    }

    p {
      margin-top: 10px;
      font-size: 15px;
      line-height: 20px;
      color: ${({ theme }) => theme.color.gray[600]};
    }

    .order-btn {
      margin-top: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 55px;
      border-radius: 6px;
      font-weight: 500;
      background-color: ${({ theme }) => theme.color.gray[900]};
      color: ${({ theme }) => theme.color.background};
      transition: 0.2s;

      .spinner {
        margin-right: 12px;
        display: flex;
      }

      &:hover {
        background-color: ${({ theme }) => theme.color.gray[700]};
      }

      &:disabled {
        background-color: ${({ theme }) => theme.color.gray[200]};
        color: ${({ theme }) => theme.color.gray[400]};

        &:hover {
          background-color: ${({ theme }) => theme.color.gray[200]};
          cursor: not-allowed;
        }
      }
    }
  }
`

export default StyledConfirmationView
